module.exports = __webpack_public_path__ + "img/profiles@2x.7b62674.jpg";